
import {
  getDataFromLocalStorage,

  setDataToLocalStorage,
  SetDataOpResultTypes,

  removeDataFromLocalStorage,
  RemoveDataOpResultTypes,

  /* eslint-disable no-unused-vars */
  SetDataResult,
  /* eslint-enable no-unused-vars */
} from "app/local_storages/native_api_adapter"


const STORAGE_KEY_PREFIX = "contact_info_storage"

const STORAGE_KEYS = {
  user_authentication_handle: `${STORAGE_KEY_PREFIX}/user_authentication_handle`,

  contact_name: `${STORAGE_KEY_PREFIX}/contact_name`,

  contact_email_address: `${STORAGE_KEY_PREFIX}/contact_email_address`,

  contact_phone_number:               `${STORAGE_KEY_PREFIX}/contact_phone_number`,
  contact_phone_number_country_code:  `${STORAGE_KEY_PREFIX}/contact_phone_number_country_code`,
}

interface ContactInfoData {
  user_authentication_handle: string | null,

  contact_name: string | null,

  contact_email_address: string | null,

  contact_phone_number: string | null,
  contact_phone_number_country_code: string | null,
}


const getContactInfoData = (): ContactInfoData => {
  return {
    user_authentication_handle:
      getDataFromLocalStorage(STORAGE_KEYS.user_authentication_handle).data,

    contact_name:
      getDataFromLocalStorage(STORAGE_KEYS.contact_name).data,

    contact_email_address:
      getDataFromLocalStorage(STORAGE_KEYS.contact_email_address).data,

    contact_phone_number:
      getDataFromLocalStorage(STORAGE_KEYS.contact_phone_number).data,
    contact_phone_number_country_code:
      getDataFromLocalStorage(STORAGE_KEYS.contact_phone_number_country_code).data,
  }
}


interface SetContactInfoDataInput {
  user_authentication_handle?: string | null,

  contact_name?: string | null,

  contact_email_address?: string | null,

  contact_phone_number?:  string | null,
  contact_phone_number_country_code?: string | null,
}

const setContactInfoData = ({
  contact_name,
  contact_email_address,
  contact_phone_number,
  contact_phone_number_country_code,
  user_authentication_handle,
}: SetContactInfoDataInput): SetDataResult => {
  if (contact_name != null) {
    const op_result = setDataToLocalStorage(
      STORAGE_KEYS.contact_name,
      contact_name,
    )
    if (op_result.result_type !== SetDataOpResultTypes.DATA_IS_SET) {
      return op_result
    }
  }

  if (contact_email_address != null) {
    const op_result = setDataToLocalStorage(
      STORAGE_KEYS.contact_email_address,
      contact_email_address,
    )
    if (op_result.result_type !== SetDataOpResultTypes.DATA_IS_SET) {
      return op_result
    }
  }

  if (contact_phone_number != null) {
    const op_result = setDataToLocalStorage(
      STORAGE_KEYS.contact_phone_number,
      contact_phone_number,
    )
    if (op_result.result_type !== SetDataOpResultTypes.DATA_IS_SET) {
      return op_result
    }
  }

  if (contact_phone_number_country_code != null) {
    const op_result = setDataToLocalStorage(
      STORAGE_KEYS.contact_phone_number_country_code,
      contact_phone_number_country_code,
    )
    if (op_result.result_type !== SetDataOpResultTypes.DATA_IS_SET) {
      return op_result
    }
  }

  if (user_authentication_handle != null) {
    const op_result = setDataToLocalStorage(
      STORAGE_KEYS.user_authentication_handle,
      user_authentication_handle,
    )
    if (op_result.result_type !== SetDataOpResultTypes.DATA_IS_SET) {
      return op_result
    }
  }
  // Allow clearing data with `null` value
  // `null` only, not `undefined`
  // This is required since we need to clear the data on sign-out
  else if (user_authentication_handle === null) {
    const op_result = removeDataFromLocalStorage(
      STORAGE_KEYS.user_authentication_handle,
    )
    if (op_result.result_type !== RemoveDataOpResultTypes.DATA_REMOVED) {
      return op_result
    }
  }

  return {
    result_type: SetDataOpResultTypes.DATA_IS_SET,
  }
}



export {
  getContactInfoData,
  setContactInfoData,
}
